import styled, { SimpleInterpolation, css } from "styled-components";

export const CollapseTitle = styled.div`
  margin-left: 15px;
  font-size: 12px;
  font-weight: 600;
  min-width: max-content;
`;

export const CollapseWrapper = styled.div<{
  customCSS?: SimpleInterpolation;
  duration: number;
}>`
  position: relative;
  width: 100%;
  color: #e0edef;
  .collapse-arrow {
    transform: translate(0, -50%) rotate(-90deg);
    &.active {
      transform: translate(0, -50%);
    }
  }
  .collapse-children {
    transition: ${(p) => `opacity ${p.duration / 1000}s ease-in-out`};
  }
  ${(p) => p.customCSS};
`;

export const CollapseOperation = styled.div`
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 34px;
  background: #212326;
  cursor: pointer;
  padding: 0 15px;
  .collapse-arrow {
    position: absolute;
    left: 14px;
    top: 50%;
    transition: all 0.2s ease-in-out;
  }
`;

export const CollapseChildren = styled.div`
  position: absolute;
  opacity: 0;
  width: 100%;
  pointer-events: none;
  overflow: hidden;
  &.active {
    position: relative;
    height: max-content;
    overflow: unset;
    opacity: 1;
    pointer-events: unset;
  }
  .loading-wrapper {
    position: relative;
    width: 100%;
    height: 120px;
    background: ${(p) => p.theme["gray-4"]};
  }
`;
